import styled from 'styled-components';

import { Z_INDICES } from 'verify/styles/variables';

const Bar = styled('div')<{ widthPercentage: number }>`
  width: ${(props) => props.widthPercentage}%;
  transition: width 0.5s;
  height: 5px;
  background-color: ${({ theme }) => theme.colorProgressBar};
  position: absolute;
  z-index: ${Z_INDICES.navbar};
`;

interface ProgressBarProps {
  widthPercentage?: number;
  className?: string;
}

export default ({ widthPercentage, className }: ProgressBarProps) => {
  return (
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    <Bar className={className} data-test='header__progress-bar' widthPercentage={widthPercentage} />
  );
};
